import { format, max, min, parseISO, subDays } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import React, { useState } from 'react'
import { useQuery } from 'react-query'

import { DashboardsService } from '../../../../services/http/dashboards.service'
import MenuRadio from '../../../Mantine/MenuRadio'
import LineSkeleton from '../../../Mantine/Skeleton/line'

import Grafico from './Grafico'
import * as S from './styles'

const DEFAULT_DATA = { start: null, stop: null }

const formatDate = (date) => format(date, 'dd/MM/yyyy - EEEE', { locale: ptBR })
const options = [
  {
    value: 'periodo',
    label: 'Por período',
    inputFields: {
      component: 'DatePicker',
      fields: [
        { value: 'start', label: 'De:' },
        { value: 'stop', label: 'Até:' }
      ]
    }
  },
  { value: '24h', label: 'Últimas 24h' },
  { value: '48h', label: 'Últimas 48h' },
  { value: '7d', label: 'Últimos 7 dias' },
  { value: '15d', label: 'Últimos 15 dias' },
  { value: '30d', label: 'Últimos 30 dias' }
]

export default function Historico() {
  const [selectedButton, setSelectedButton] = useState('24h')
  // const [mostrarAlerta, setMostrarAlerta] = useState(false)
  const [selectedDate, setSelectedDate] = useState({ ...DEFAULT_DATA })
  const [visibleDate, setVisibleDate] = useState(false)
  const [loading, setLoading] = useState()

  const [datasDisponiveis, setDatasDisponiveis] = useState({
    min: undefined,
    max: undefined
  })

  const isPeriodo = selectedButton === 'periodo'

  const today = new Date()

  const { getHistoricoPortadoras } = DashboardsService

  const { data } = useQuery(
    [`carrier/history/conections`, selectedButton, selectedDate],
    async () => {
      try {
        setLoading(true)
        return await getHistoricoPortadoras(selectedButton, selectedDate)
      } catch (err) {
        console.error('Erro ao buscar consumo:', err)
        return []
      } finally {
        setLoading(false)
      }
    },
    {
      onSuccess: (data) => {
        if (!data?.length) return

        const parsedDates = data.map((item) => parseISO(item.data))

        // const today = new Date()
        const minDate = min(parsedDates)
        const maxDate = max(parsedDates)
        setDatasDisponiveis({
          min: minDate,
          max: maxDate
        })

        // if (isPeriodo) {
        //   const isMaxDateBeforeSelectedEnd = selectedDate.end
        //     ? isBefore(maxDate, selectedDate.end)
        //     : false

        //   const isMinDateAfterSelectedStart = selectedDate.start
        //     ? isAfter(minDate, selectedDate.start)
        //     : false

        //   if (isMinDateAfterSelectedStart || isMaxDateBeforeSelectedEnd) {
        //     setMostrarAlerta(true)
        //   } else {
        //     setMostrarAlerta(false)
        //   }

        //   return
        // }

        // const isMaxDateBeforeToday = isBefore(maxDate, today)

        // const days = parseInt(selectedButton, 10)
        // const startDate = subDays(today, days)

        // const isMinDateAfterStartDate = isAfter(minDate, startDate)

        // if (isMinDateAfterStartDate || isMaxDateBeforeToday) {
        //   setMostrarAlerta(true)
        // } else {
        //   setMostrarAlerta(false)
        // }
      },
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  )

  const getLegenda = () => {
    let startDate

    switch (selectedButton) {
      case '24h':
        return `${formatDate(today)}`
      case '48h':
        startDate = subDays(today, 2)
        return `De ${formatDate(startDate)} até ${formatDate(today)}`
      case '7d':
      case '15d':
      case '30d':
        const days = parseInt(selectedButton)
        startDate = subDays(today, days)
        return `De ${formatDate(startDate)} até ${formatDate(today)}`
      case 'periodo':
        const days2 = parseInt(selectedButton)
        startDate = subDays(today, days2)
        return `De ${formatDate(datasDisponiveis.min)} até ${formatDate(datasDisponiveis.max)}`
      default:
        return ''
    }
  }

  // const handleFecharAlerta = () => setMostrarAlerta(false)

  const handleFilter = (value) => {
    if (!value.type) return

    if (value.type !== 'periodo') {
      setVisibleDate(false)
      setSelectedDate({ ...DEFAULT_DATA })
    } else {
      setVisibleDate(true)
      setSelectedDate(value.period)
    }

    setSelectedButton(value.type)
    // setMostrarAlerta(false)
  }

  return (
    <S.HistoricoWrapper>
      <S.DashboardHeader className="dash-boardheader">
        <div>
          <S.Title>Histórico de conexões</S.Title>
          <S.SubTitle>
            {options.find((option) => option.value === selectedButton)?.label}
          </S.SubTitle>
        </div>
        <MenuRadio options={options} onClick={handleFilter} scaleIcon={1} />
      </S.DashboardHeader>
      {loading && <LineSkeleton height={305} visible={loading} />}
      {!loading && (
        <>
          <Grafico
            selectedDate={selectedDate}
            data={data}
            visibleDate={visibleDate}
          />
          {data?.length > 0 && <S.Legenda>{getLegenda()}</S.Legenda>}
          {/* {mostrarAlerta && (
            <S.AlertWrapper>
              <AlertMantine
                radius="sm"
                title="Atenção!"
                type="warning"
                color="yellow"
                withCloseButton
                onClose={handleFecharAlerta}
                icon={<InfoIcon alt="info" />}
              >
                {`Nem todos os dias do período selecionado possuem dados disponíveis. Estamos exibindo as informações de ${formatDateToLabel(datasDisponiveis.min)} a  ${formatDateToLabel(datasDisponiveis.max)}.`}
              </AlertMantine>
            </S.AlertWrapper>
          )} */}
        </>
      )}
    </S.HistoricoWrapper>
  )
}
